import React from 'react'

function YesterdayReport() {
  return (
    <div>YesterdayReport</div>
  )
}

export default YesterdayReport